//import React, { useState, useEffect } from 'react';
//import { FiDownload, FiUpload } from "react-icons/fi";
//import { MdOutlineDeleteForever } from "react-icons/md";
//import { CgCloseR } from "react-icons/cg";
//import { AiOutlineSortAscending } from "react-icons/ai";
//import { useSelector } from "react-redux";
//import Loading from "../../component/Loading/Loading";
//import AlertMsg from '../../component/AlertMsg/AlertMsg';
//import { FaSearch, FaRegWindowClose } from "react-icons/fa";
//import { Search, Plus, Upload, Download } from "lucide-react";
//import Pagination from '../../utils/Pagenation/Pagenation';
//import useAxiosInstance from '../../services/useAxiosInstance';
//import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

//const CommunityDocuments = () => {
//  const axiosInstance = useAxiosInstance();
//  const communityId = useSelector((state) => state.auth.communityId);
//  const userId = useSelector((state) => state.auth.userId);
//  const currentDate = new Date().toISOString();
//  const [userDetails, setUserDetails] = useState({});
//  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
//  const [formData, setFormData] = useState({
//    communitydocumentid: 0,
//    communityid: communityId,
//    ownerid: userId,
//    name: '',
//    uploadeddate: currentDate,
//    uploadedbyid: userId,
//    documenturl: '',
//    createdbyid: userId,
//    modifiedbyid: userId,
//    createddate: currentDate,
//    modifieddate: currentDate,
//    documenttype: ''
//  });

//  const [selectedFile, setSelectedFile] = useState(null);
//  const [activeButton, setActiveButton] = useState(null);
//  const [showAddForm, setShowAddForm] = useState(false);
//  const [showcommunityForm, setShowcommunityForm] = useState(false);
//  const [currentPage, setCurrentPage] = useState(0);
//  const itemsPerPage = 10;
//  const [isPopupOpen, setIsPopupOpen] = useState(false);
//  const [formErrors, setFormErrors] = useState({});
//  const [data, setData] = useState([]);
//  const [loading, setLoading] = useState(false);
//  const [error, setError] = useState(null);
//  const [searchName, setSearchName] = useState("");
//  const [communitydocument, setCommunityDocument] = useState("");
//  const handleClick = (btnNumber) => {
//    setActiveButton(btnNumber);
//  };

//  const handleChange = (e) => {
//    const { name, value } = e.target;
//    setFormData((prevState) => ({
//      ...prevState,
//      [name]: value,
//    }));
//  };

//  const handleFileChange = (event) => {
//    setSelectedFile(event.target.files[0]);
//  };

//  const handleFile = (file) => {
//    if (file) {
//      if (file.type === 'application/pdf') {
//        if (file.size <= 5 * 1024 * 1024) {
//          setSelectedFile(file);
//        } else {
//          alert('File size must be below 5 MB.');
//        }
//      } else {
//        alert('Only PDF files are allowed.');
//      }
//    }
//  };

//  const handleAddcommunityClick = () => {
//    setShowcommunityForm(!showcommunityForm);
//  };

//  const pageCount = Math.ceil(data.length / itemsPerPage);

//  const filteredData = data
//    .filter((item) => item.name.toLowerCase().includes(searchName.toLowerCase()))
//    .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);


//  const validateForm = () => {
//    let isValid = true;
//    const errors = {};

//    if (!formData.name.trim()) {
//      errors.name = 'Name is required.';
//      isValid = false;
//    }

//    if (!formData.documenttype.trim()) {
//      errors.documenttype = 'Document Type is required.';
//      isValid = false;
//    }

//    if (!selectedFile) {
//      errors.documenturl = 'Document is required.';
//      isValid = false;
//    }

//    setFormErrors(errors);
//    return isValid;
//  };


//  const handleCancelClick = () => {
//    setFormData({
//      communitydocumentid: 0,
//      communityid: communityId,
//      ownerid: userId,
//      name: '',
//      uploadeddate: currentDate,
//      uploadedbyid: userId,
//      documenturl: '',
//      createdbyid: userId,
//      modifiedbyid: userId,
//      createddate: currentDate,
//      modifieddate: currentDate,
//      documenttype: ''
//    });
//    setFormErrors({});
//    setShowAddForm(false);
//    setShowcommunityForm(false);
//  };

//  const handleSubmit = async (e) => {
//    e.preventDefault();
//    setLoading(true);
//    const isValid = validateForm();

//    if (!selectedFile) {
//      setFormErrors((prevState) => ({ ...prevState, documenturl: 'Document is required.' }));
//      return;
//    }
//    if (!isValid) {
//      return;
//    }
//    setShowcommunityForm(false);
//    try {
//      let newDocUrl = formData.documenturl;
//      if (selectedFile) {
//        const uploadFormData = new FormData();
//        uploadFormData.append('file', selectedFile);
//        try {
//          const uploadResponse = await axiosInstance.post(
//            `/api/public/communitydocument/communityDocumentUpload`,
//            uploadFormData, {
//            headers: {
//              'Content-Type': 'multipart/form-data'
//            }
//          });
//          newDocUrl = uploadResponse.data;
//        } catch (error) {
//          console.error('Error uploading file', error);
//          return;
//        }
//      }

//      const updatedFormData = {
//        ...formData,
//        documenturl: newDocUrl,
//      };

//      const response = await axiosInstance.post(`/api/public/communitydocument/add`, updatedFormData);
//      fetchCommunityDocuments();
//      setFormData({
//        communitydocumentid: 0,
//        communityid: communityId,
//        ownerid: userId,
//        name: '',
//        uploadeddate: currentDate,
//        uploadedbyid: userId,
//        documenturl: '',
//        createdbyid: userId,
//        modifiedbyid: userId,
//        createddate: currentDate,
//        modifieddate: currentDate,
//        documenttype: ''
//      });
//      setAlert({ visible: true, message: 'Community document added successfully!', type: 'success' });
//    } catch (error) {
//      console.error('Error adding document:', error);
//      setAlert({ visible: true, message: 'Error adding Community document. Please try again later', type: 'error' });
//    } finally {
//      setLoading(false);
//    }
//  };



//  const fetchCommunityDocuments = async () => {
//    setLoading(true);
//    try {
//      const response = await axiosInstance.get(
//        `/api/public/communitydocument/community/${communityId}`
//      );
//      const documents = response.data;
//      setData(documents);
//      setCommunityDocument(response.data);
//      const userDetailsMap = {};
//      for (const doc of documents) {
//        if (doc.uploadedbyid) {
//          const userDetails = await fetchUserDetails(doc.uploadedbyid);
//          userDetailsMap[doc.uploadedbyid] = userDetails;
//        }
//      }
//      setUserDetails(userDetailsMap);
//    } catch (error) {
//      setError(error);
//      console.error("Error fetching community documents:", error);
//    } finally {
//      setLoading(false);
//    }
//  };

//  useEffect(() => {
//    fetchCommunityDocuments();
//  }, []);

//  const fetchUserDetails = async (userId) => {
//    try {
//      const response = await axiosInstance.get(`/api/user/getById/${userId}`);
//      return response.data;
//    } catch (error) {
//      console.error('Error fetching user details:', error);
//      return null;
//    }
//  };
//  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//  const [commanDocumentToDelete, setCommanDocumentToDelete] = useState(null);
//  const handleDeleteIconClick = (communitydocumentid) => {
//    setCommanDocumentToDelete(communitydocumentid);
//    setShowDeleteConfirm(true);
//  };

//  const handleDeleteConfirm = async () => {
//    setShowDeleteConfirm(false);
//    setLoading(true);
//    if (commanDocumentToDelete) {
//      try {
//        await axiosInstance.delete(
//          `/api/public/communitydocument/delete/${commanDocumentToDelete}`);
//        fetchCommunityDocuments();
//        setCommanDocumentToDelete(null);
//        setShowDeleteConfirm(false);
//        setAlert({ visible: true, message: 'Community Documents deleted successfully!', type: 'success' });
//      } catch (error) {
//        console.error("Error deleting Community Documents:", error);
//        setAlert({ visible: true, message: 'Error deleting Community Documents: Please try again.', type: 'error' });
//      } finally {
//        setLoading(false);
//      }
//    }
//  };
//  const handleDeleteCancel = () => {
//    setCommanDocumentToDelete(null);
//    setShowDeleteConfirm(false);
//  };


//  const handleSearchChange = (event) => {
//    setSearchName(event.target.value);
//    setCurrentPage(0);
//  };


//  const [sortOrder, setSortOrder] = useState('asc')
//  const handleSort = () => {
//    const sortedRolePages = [...data].sort((a, b) => {
//      const pageNameA = a.name.toLowerCase();
//      const pageNameB = b.name.toLowerCase();

//      if (sortOrder === 'asc') {
//        return pageNameA.localeCompare(pageNameB);
//      } else {
//        return pageNameB.localeCompare(pageNameA);
//      }
//    });


//    setData(sortedRolePages);
//    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
//  };

//  // Modal footer for upload form
//  const uploadModalFooter = (
//    <div className="flex justify-end space-x-2">
//      <button
//        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
//        onClick={handleCancelClick}
//      >
//        Cancel
//      </button>
//      <button
//        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//        onClick={handleSubmit}
//      >
//        Submit
//      </button>
//    </div>
//  );

//  // Modal footer for delete confirmation
//  const deleteModalFooter = (
//    <div className="flex justify-end space-x-2">
//      <button
//        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
//        onClick={handleDeleteCancel}
//      >
//        Cancel
//      </button>
//      <button
//        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
//        onClick={handleDeleteConfirm}
//      >
//        Delete
//      </button>
//    </div>
//  );
//    // Add this function inside the component (before the return statement)
//    const handleDownload = async (url, fileName) => {
//        try {
//            // Start loading indicator
//            setLoading(true);

//            // Fetch the file from the URL
//            const response = await fetch(url);
//            const blob = await response.blob();

//            // Create a blob URL for the file
//            const blobUrl = window.URL.createObjectURL(blob);

//            // Create a temporary anchor element
//            const downloadLink = document.createElement('a');
//            downloadLink.href = blobUrl;
//            downloadLink.download = fileName || 'document'; // Use provided filename or default

//            // Append to the body, click it to trigger download, then remove
//            document.body.appendChild(downloadLink);
//            downloadLink.click();
//            document.body.removeChild(downloadLink);

//            // Clean up the blob URL
//            window.URL.revokeObjectURL(blobUrl);
//        } catch (error) {
//            console.error('Error downloading file:', error);
//            setAlert({ visible: true, message: 'Error downloading file. Please try again.', type: 'error' });
//        } finally {
//            // Stop loading indicator
//            setLoading(false);
//        }
//    };

//  return (
//    <div className="bg-gray-50 min-h-screen md:p-4">
//      {loading && <Loading />}
//      {!loading && (
//        <div className="max-w-7xl mx-auto">
//          {alert.visible && (
//            <AlertMsg
//              message={alert.message}
//              type={alert.type}
//              onClose={() => setAlert({ ...alert, visible: false })}
//            />
//          )}

//          <div className="flex justify-between items-center mb-6">
//            <h1 className="text-2xl font-bold text-gray-800">Community Documents</h1>
//            <div className="flex items-center">
//              <button
//                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
//                onClick={handleAddcommunityClick}
//              >
//                <FiUpload size={18} />
//                <span className='md:inline hidden'>Upload</span>
//              </button>
//            </div>
//          </div>

//          <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
//            <div className="flex flex-wrap md:flex-nowrap justify-between items-center p-4">
//              <div className="relative w-full md:w-80 mb-4 md:mb-0">
//                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
//                  <Search className="h-5 w-5 text-gray-400" />
//                </div>
//                <input
//                  type="text"
//                  id="searchName"
//                  value={searchName}
//                  onChange={handleSearchChange}
//                  placeholder="Search by File name"
//                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
//                />
//              </div>

//            </div>

//            <div className="overflow-x-auto">
//              <table className="min-w-full divide-y divide-gray-200">
//                <thead className="bg-blue-400">
//                  <tr>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">File Name    <button
//                      onClick={handleSort}
//                    >
//                      <AiOutlineSortAscending className="inline ml-1" />
//                    </button>
//                    </th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">File Type</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Uploaded Date</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Uploaded By</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Document</th>
//                    <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Action</th>
//                  </tr>
//                </thead>
//                <tbody className="bg-white divide-y divide-gray-200">
//                  {filteredData.length === 0 ? (
//                    <tr>
//                      <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
//                    </tr>
//                  ) : filteredData.map((item, index) => (
//                    <tr key={item.communitydocumentid} className={index % 2 === 0 ? "" : "bg-gray-50"}>
//                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.name}</td>
//                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.documenttype}</td>
//                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Date(item.uploadeddate).toLocaleDateString()}</td>
//                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                        {userDetails[item.uploadedbyid]?.firstName}
//                      </td>
//                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
//                        {item.documenturl ? (
//                          <a href={item.documenturl} target="_blank" rel="noopener noreferrer">
//                            <img src={item.documenturl} alt="document" width="50" height="50" />
//                          </a>
//                        ) : (
//                          <p>No Image</p>
//                        )}
//                      </td>
//                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-3">
//                        <button
//                          className="text-red-500 hover:text-red-700 mr-3"
//                          onClick={() => handleDeleteIconClick(item.communitydocumentid)}
//                          title="Delete Document"
//                        >
//                          <MdOutlineDeleteForever size={20} />
//                        </button>
//                        {/*<button*/}
//                        {/*>*/}
//                        {/*  <Download size={18} />*/}
//                        {/*</button>*/}
//                              <button
//                                  onClick={() => handleDownload(item.documenturl, item.name)}
//                                  className="text-blue-500 hover:text-blue-700"
//                              >
//                                  <Download size={18} />
//                              </button>
//                      </td>
//                    </tr>
//                  ))}
//                </tbody>
//              </table>
//            </div>

//            <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
//              <div className="text-sm text-gray-700">
//                Page {currentPage + 1} of {pageCount || 1}
//              </div>
//              <div className="flex-1 flex justify-end">
//                <Pagination
//                  currentPage={currentPage}
//                  pageCount={pageCount}
//                  setCurrentPage={setCurrentPage}
//                />
//              </div>
//            </div>
//          </div>
//        </div>
//      )
//      }

//      {/* Upload Document Modal using GlassmorphicModal */}
//      <GlassmorphicModal
//        isOpen={showcommunityForm}
//        onClose={handleCancelClick}
//        title="Upload Community Document"
//        size="lg"
//        footer={uploadModalFooter}
//      >
//        <div className="space-y-6">
//          <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              File Name <span className="text-red-500">*</span>
//            </label>
//            <input
//              type="text"
//              className={`w-full rounded-md border ${formErrors.name ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//              placeholder="Enter Name"
//              name="name"
//              value={formData.name}
//              onChange={handleChange}
//            />
//            {formErrors.name && <p className="text-red-500 text-xs mt-1">{formErrors.name}</p>}
//          </div>

//          <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              Document Type <span className="text-red-500">*</span>
//            </label>
//            <input
//              type="text"
//              className={`w-full rounded-md border ${formErrors.documenttype ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//              placeholder="Enter Document Type"
//              name="documenttype"
//              value={formData.documenttype}
//              onChange={handleChange}
//            />
//            {formErrors.documenttype && <p className="text-red-500 text-xs mt-1">{formErrors.documenttype}</p>}
//          </div>

//          {/* <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              Upload Document <span className="text-red-500">*</span>
//            </label>
//            <input
//              type="file"
//              className={`w-full rounded-md border ${formErrors.documenturl ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//              name="documenturl"
//              onChange={handleFileChange}
//            />
//            {formErrors.documenturl && <p className="text-red-500 text-xs mt-1">{formErrors.documenturl}</p>}
//          </div>
//          */}


//          <div>
//            <label className="block text-sm font-medium text-gray-700 mb-1">
//              Upload Document <span className="text-red-500">*</span>
//            </label>
//            <div className="mt-1 flex items-center">
//              <label className={`w-full flex items-center justify-center px-4 py-2 border ${formErrors.documenturl ? "border-red-500" : "border-gray-300"} rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 cursor-pointer focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500`}>
//                <Upload className="h-5 w-5 text-gray-400 mr-2" />
//                <span>Choose file</span>
//                <input
//                  type="file"
//                  className="sr-only"
//                  name="documenturl"
//                  onChange={handleFileChange}
//                  accept="*/*"
//                />
//              </label>
//            </div>
//            {formErrors.documenturl && <p className="text-red-500 text-xs mt-1">{formErrors.documenturl}</p>}
//          </div>




//          <div className="text-sm text-red-500">* indicates required field</div>
//        </div>
//      </GlassmorphicModal>

//      {/* Delete Confirmation Modal using GlassmorphicModal */}
//      <GlassmorphicModal
//        isOpen={showDeleteConfirm}
//        onClose={handleDeleteCancel}
//        title="Confirm Delete"
//        size="sm"
//        footer={deleteModalFooter}
//      >
//        <p className="text-gray-700">
//          Are you sure you want to delete this Community Document? This action cannot be undone.
//        </p>
//      </GlassmorphicModal>
//    </div >
//  );
//};

//export default CommunityDocuments;

import React, { useState, useEffect } from 'react';
import { FiDownload, FiUpload } from "react-icons/fi";
import { MdOutlineDeleteForever } from "react-icons/md";
import { CgCloseR } from "react-icons/cg";
import { AiOutlineSortAscending } from "react-icons/ai";
import { useSelector } from "react-redux";
import Loading from "../../component/Loading/Loading";
import AlertMsg from '../../component/AlertMsg/AlertMsg';
import { FaSearch, FaRegWindowClose } from "react-icons/fa";
import { Search, Plus, Upload, Download } from "lucide-react";
import { FiFileText, FiImage, FiFile } from "react-icons/fi";
import { AiOutlineFileExcel } from "react-icons/ai";
import { BiCodeAlt } from "react-icons/bi";
import { BsFileZip } from "react-icons/bs";
import Pagination from '../../utils/Pagenation/Pagenation';
import useAxiosInstance from '../../services/useAxiosInstance';
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

const CommunityDocuments = () => {
    const axiosInstance = useAxiosInstance();
    const communityId = useSelector((state) => state.auth.communityId);
    const userId = useSelector((state) => state.auth.userId);
    const currentDate = new Date().toISOString();
    const [userDetails, setUserDetails] = useState({});
    const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
    const [formData, setFormData] = useState({
        communitydocumentid: 0,
        communityid: communityId,
        ownerid: userId,
        name: '',
        uploadeddate: currentDate,
        uploadedbyid: userId,
        documenturl: '',
        createdbyid: userId,
        modifiedbyid: userId,
        createddate: currentDate,
        modifieddate: currentDate,
        documenttype: ''
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [activeButton, setActiveButton] = useState(null);
    const [showAddForm, setShowAddForm] = useState(false);
    const [showcommunityForm, setShowcommunityForm] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchName, setSearchName] = useState("");
    const [communitydocument, setCommunityDocument] = useState("");
    const handleClick = (btnNumber) => {
        setActiveButton(btnNumber);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleFile = (file) => {
        if (file) {
            if (file.type === 'application/pdf') {
                if (file.size <= 5 * 1024 * 1024) {
                    setSelectedFile(file);
                } else {
                    alert('File size must be below 5 MB.');
                }
            } else {
                alert('Only PDF files are allowed.');
            }
        }
    };

    const handleAddcommunityClick = () => {
        setShowcommunityForm(!showcommunityForm);
    };

    const pageCount = Math.ceil(data.length / itemsPerPage);

    const filteredData = data
        .filter((item) => item.name.toLowerCase().includes(searchName.toLowerCase()))
        .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);


    const validateForm = () => {
        let isValid = true;
        const errors = {};

        if (!formData.name.trim()) {
            errors.name = 'Name is required.';
            isValid = false;
        }

        if (!formData.documenttype.trim()) {
            errors.documenttype = 'Document Type is required.';
            isValid = false;
        }

        if (!selectedFile) {
            errors.documenturl = 'Document is required.';
            isValid = false;
        }

        setFormErrors(errors);
        return isValid;
    };


    const handleCancelClick = () => {
        setFormData({
            communitydocumentid: 0,
            communityid: communityId,
            ownerid: userId,
            name: '',
            uploadeddate: currentDate,
            uploadedbyid: userId,
            documenturl: '',
            createdbyid: userId,
            modifiedbyid: userId,
            createddate: currentDate,
            modifieddate: currentDate,
            documenttype: ''
        });
        setFormErrors({});
        setShowAddForm(false);
        setShowcommunityForm(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const isValid = validateForm();

        if (!selectedFile) {
            setFormErrors((prevState) => ({ ...prevState, documenturl: 'Document is required.' }));
            return;
        }
        if (!isValid) {
            return;
        }
        setShowcommunityForm(false);
        try {
            let newDocUrl = formData.documenturl;
            if (selectedFile) {
                const uploadFormData = new FormData();
                uploadFormData.append('file', selectedFile);
                try {
                    const uploadResponse = await axiosInstance.post(
                        `/api/public/communitydocument/communityDocumentUpload`,
                        uploadFormData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    newDocUrl = uploadResponse.data;
                } catch (error) {
                    console.error('Error uploading file', error);
                    return;
                }
            }

            const updatedFormData = {
                ...formData,
                documenturl: newDocUrl,
            };

            const response = await axiosInstance.post(`/api/public/communitydocument/add`, updatedFormData);
            fetchCommunityDocuments();
            setFormData({
                communitydocumentid: 0,
                communityid: communityId,
                ownerid: userId,
                name: '',
                uploadeddate: currentDate,
                uploadedbyid: userId,
                documenturl: '',
                createdbyid: userId,
                modifiedbyid: userId,
                createddate: currentDate,
                modifieddate: currentDate,
                documenttype: ''
            });
            setAlert({ visible: true, message: 'Community document added successfully!', type: 'success' });
        } catch (error) {
            console.error('Error adding document:', error);
            setAlert({ visible: true, message: 'Error adding Community document. Please try again later', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleDownload = async (url, fileName) => {
        try {
            // Start loading indicator
            setLoading(true);

            // Fetch the file from the URL
            const response = await fetch(url);
            const blob = await response.blob();

            // Create a blob URL for the file
            const blobUrl = window.URL.createObjectURL(blob);

            // Create a temporary anchor element
            const downloadLink = document.createElement('a');
            downloadLink.href = blobUrl;
            downloadLink.download = fileName || 'document'; // Use provided filename or default

            // Append to the body, click it to trigger download, then remove
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);

            // Clean up the blob URL
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Error downloading file:', error);
            setAlert({ visible: true, message: 'Error downloading file. Please try again.', type: 'error' });
        } finally {
            // Stop loading indicator
            setLoading(false);
        }
    };

    const fetchCommunityDocuments = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(
                `/api/public/communitydocument/community/${communityId}`
            );
            const documents = response.data;
            setData(documents);
            setCommunityDocument(response.data);
            const userDetailsMap = {};
            for (const doc of documents) {
                if (doc.uploadedbyid) {
                    const userDetails = await fetchUserDetails(doc.uploadedbyid);
                    userDetailsMap[doc.uploadedbyid] = userDetails;
                }
            }
            setUserDetails(userDetailsMap);
        } catch (error) {
            setError(error);
            console.error("Error fetching community documents:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCommunityDocuments();
    }, []);

    const fetchUserDetails = async (userId) => {
        try {
            const response = await axiosInstance.get(`/api/user/getById/${userId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching user details:', error);
            return null;
        }
    };
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [commanDocumentToDelete, setCommanDocumentToDelete] = useState(null);
    const handleDeleteIconClick = (communitydocumentid) => {
        setCommanDocumentToDelete(communitydocumentid);
        setShowDeleteConfirm(true);
    };

    const handleDeleteConfirm = async () => {
        setShowDeleteConfirm(false);
        setLoading(true);
        if (commanDocumentToDelete) {
            try {
                await axiosInstance.delete(
                    `/api/public/communitydocument/delete/${commanDocumentToDelete}`);
                fetchCommunityDocuments();
                setCommanDocumentToDelete(null);
                setShowDeleteConfirm(false);
                setAlert({ visible: true, message: 'Community Documents deleted successfully!', type: 'success' });
            } catch (error) {
                console.error("Error deleting Community Documents:", error);
                setAlert({ visible: true, message: 'Error deleting Community Documents: Please try again.', type: 'error' });
            } finally {
                setLoading(false);
            }
        }
    };
    const handleDeleteCancel = () => {
        setCommanDocumentToDelete(null);
        setShowDeleteConfirm(false);
    };


    const handleSearchChange = (event) => {
        setSearchName(event.target.value);
        setCurrentPage(0);
    };


    const [sortOrder, setSortOrder] = useState('asc')
    const handleSort = () => {
        const sortedRolePages = [...data].sort((a, b) => {
            const pageNameA = a.name.toLowerCase();
            const pageNameB = b.name.toLowerCase();

            if (sortOrder === 'asc') {
                return pageNameA.localeCompare(pageNameB);
            } else {
                return pageNameB.localeCompare(pageNameA);
            }
        });


        setData(sortedRolePages);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    };

    // Helper functions for document preview
    const getFileTypeFromUrl = (url) => {
        if (!url) return 'unknown';

        const extension = url.split('.').pop().toLowerCase();

        const fileTypeMap = {
            // Images
            'jpg': 'image', 'jpeg': 'image', 'png': 'image', 'gif': 'image', 'bmp': 'image', 'svg': 'image',
            // Documents
            'pdf': 'pdf', 'doc': 'doc', 'docx': 'doc',
            // Spreadsheets
            'xls': 'spreadsheet', 'xlsx': 'spreadsheet', 'csv': 'spreadsheet',
            // Code
            'js': 'code', 'html': 'code', 'css': 'code', 'json': 'code',
            // Archives
            'zip': 'archive', 'rar': 'archive', '7z': 'archive',
        };

        return fileTypeMap[extension] || 'other';
    };

    const getFileIcon = (fileType, size = 24) => {
        switch (fileType) {
            case 'image':
                return <FiImage size={size} />;
            case 'pdf':
            case 'doc':
                return <FiFileText size={size} />;
            case 'spreadsheet':
                return <AiOutlineFileExcel size={size} />;
            case 'code':
                return <BiCodeAlt size={size} />;
            case 'archive':
                return <BsFileZip size={size} />;
            default:
                return <FiFile size={size} />;
        }
    };

    const formatFileSize = (bytes) => {
        if (!bytes || bytes === 0) return 'Unknown size';
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(2))} ${sizes[i]}`;
    };

    // Document preview component
    const DocumentPreview = ({ document }) => {
        const [hasError, setHasError] = useState(false);
        const [fileSize, setFileSize] = useState(null);
        const fileType = getFileTypeFromUrl(document.documenturl);

        useEffect(() => {
            if (document.documenturl) {
                setHasError(false);

                // Get file size
                fetch(document.documenturl, { method: 'HEAD' })
                    .then(response => {
                        const size = response.headers.get('content-length');
                        if (size) {
                            setFileSize(parseInt(size, 10));
                        }
                    })
                    .catch(err => console.error('Error fetching file metadata:', err));

                // If it's an image, we'll try to load it
                if (fileType === 'image') {
                    const img = new Image();
                    img.onerror = () => {
                        setHasError(true);
                    };
                    img.src = document.documenturl;
                }
            } else {
                setHasError(true);
            }
        }, [document.documenturl, fileType]);

        return (
            <div className="relative group">
                {/*<a*/}
                {/*    href={document.documenturl}*/}
                {/*    target="_blank"*/}
                {/*    rel="noopener noreferrer"*/}
                {/*    className="block relative flex items-center justify-center w-12 h-12 border rounded-md overflow-hidden"*/}
                {/*    aria-label={`${document.name} (${fileType} file)`}*/}
                {/*>*/}
                {/*    {hasError ? (*/}
                {/*        <div className="flex flex-col items-center text-red-500">*/}
                {/*            <FiFile size={24} />*/}
                {/*            <span className="text-xs">Error</span>*/}
                {/*        </div>*/}
                {/*    ) : fileType === 'image' ? (*/}
                {/*        <img*/}
                {/*            src={document.documenturl}*/}
                {/*            alt={`Preview of ${document.name}`}*/}
                {/*            className="object-cover w-full h-full"*/}
                {/*            onError={() => setHasError(true)}*/}
                {/*        />*/}
                {/*    ) : (*/}
                {/*        getFileIcon(fileType)*/}
                {/*    )}*/}
                {/*</a>*/}
                {/* Change from anchor tag to div */}
                <div
                    className="block relative flex items-center justify-center w-12 h-12 border rounded-md overflow-hidden cursor-default"
                    aria-label={`${document.name} (${fileType} file)`}
                >
                    {hasError ? (
                        <div className="flex flex-col items-center text-red-500">
                            <FiFile size={24} />
                            <span className="text-xs">Error</span>
                        </div>
                    ) : fileType === 'image' ? (
                        <img
                            src={document.documenturl}
                            alt={`Preview of ${document.name}`}
                            className="object-cover w-full h-full"
                            onError={() => setHasError(true)}
                        />
                    ) : (
                        getFileIcon(fileType)
                    )}
                </div>
                {/* Tooltip with file information */}
                <div className="hidden group-hover:block absolute z-10 w-48 p-2 bg-white shadow-lg rounded border text-xs left-0 bottom-full mb-2">
                    <p className="font-bold truncate">{document.name}</p>
                    <p>Type: {document.documenttype || fileType.toUpperCase()}</p>
                    {fileSize && <p>Size: {formatFileSize(fileSize)}</p>}
                    <p>Uploaded: {new Date(document.uploadeddate).toLocaleDateString()}</p>
                </div>
            </div>
        );
    };

    // Modal footer for upload form
    const uploadModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                onClick={handleCancelClick}
            >
                Cancel
            </button>
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleSubmit}
            >
                Submit
            </button>
        </div>
    );

    // Modal footer for delete confirmation
    const deleteModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                onClick={handleDeleteCancel}
            >
                Cancel
            </button>
            <button
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                onClick={handleDeleteConfirm}
            >
                Delete
            </button>
        </div>
    );


    return (
        <div className="bg-gray-50 min-h-screen md:p-4">
            {loading && <Loading />}
            {!loading && (
                <div className="max-w-7xl mx-auto">
                    {alert.visible && (
                        <AlertMsg
                            message={alert.message}
                            type={alert.type}
                            onClose={() => setAlert({ ...alert, visible: false })}
                        />
                    )}

                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">Community Documents</h1>
                        <div className="flex items-center">
                            <button
                                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
                                onClick={handleAddcommunityClick}
                            >
                                <FiUpload size={18} />
                                <span className='md:inline hidden'>Upload</span>
                            </button>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                        <div className="flex flex-wrap md:flex-nowrap justify-between items-center p-4">
                            <div className="relative w-full md:w-80 mb-4 md:mb-0">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <Search className="h-5 w-5 text-gray-400" />
                                </div>
                                <input
                                    type="text"
                                    id="searchName"
                                    value={searchName}
                                    onChange={handleSearchChange}
                                    placeholder="Search by File name"
                                    className="pl-10 pr-4 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>

                        </div>

                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-blue-400">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">File Name    <button
                                            onClick={handleSort}
                                        >
                                            <AiOutlineSortAscending className="inline ml-1" />
                                        </button>
                                        </th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">File Type</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Uploaded Date</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Uploaded By</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Document</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider whitespace-nowrap">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {filteredData.length === 0 ? (
                                        <tr>
                                            <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                                        </tr>
                                    ) : filteredData.map((item, index) => (
                                        <tr key={item.communitydocumentid} className={index % 2 === 0 ? "" : "bg-gray-50"}>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.name}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.documenttype}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{new Date(item.uploadeddate).toLocaleDateString()}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {userDetails[item.uploadedbyid]?.firstName}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                {item.documenturl ? (
                                                    <DocumentPreview document={item} />
                                                ) : (
                                                    <div className="text-gray-400 flex items-center justify-center">
                                                        <FiFile size={18} />
                                                        <span className="ml-1">No document</span>
                                                    </div>
                                                )}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-3">
                                                <button
                                                    className="text-red-500 hover:text-red-700 mr-3"
                                                    onClick={() => handleDeleteIconClick(item.communitydocumentid)}
                                                    title="Delete Document"
                                                >
                                                    <MdOutlineDeleteForever size={20} />
                                                </button>
                                                <button
                                                    onClick={() => handleDownload(item.documenturl, item.name)}
                                                    title="Download Document"
                                                    className="text-blue-500 hover:text-blue-700"
                                                >
                                                    <Download size={18} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                            <div className="text-sm text-gray-700">
                                Page {currentPage + 1} of {pageCount || 1}
                            </div>
                            <div className="flex-1 flex justify-end">
                                <Pagination
                                    currentPage={currentPage}
                                    pageCount={pageCount}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )
            }

            {/* Upload Document Modal using GlassmorphicModal */}
            <GlassmorphicModal
                isOpen={showcommunityForm}
                onClose={handleCancelClick}
                title="Upload Community Document"
                size="lg"
                footer={uploadModalFooter}
            >
                <div className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            File Name <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            maxLength={100}
                            className={`w-full rounded-md border ${formErrors.name ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            placeholder="Enter Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                        {formErrors.name && <p className="text-red-500 text-xs mt-1">{formErrors.name}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Document Type <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            maxLength={100}
                            className={`w-full rounded-md border ${formErrors.documenttype ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            placeholder="Enter Document Type"
                            name="documenttype"
                            value={formData.documenttype}
                            onChange={handleChange}
                        />
                        {formErrors.documenttype && <p className="text-red-500 text-xs mt-1">{formErrors.documenttype}</p>}
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Upload Document <span className="text-red-500">*</span>
                        </label>
                        <div className="mt-1 flex items-center">
                            <label className={`w-full flex items-center justify-center px-4 py-2 border ${formErrors.documenturl ? "border-red-500" : "border-gray-300"} rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 cursor-pointer focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500`}>
                                <Upload className="h-5 w-5 text-gray-400 mr-2" />
                                <span>Choose file</span>
                                <input
                                    type="file"
                                    className="sr-only"
                                    name="documenturl"
                                    onChange={handleFileChange}
                                    accept="*/*"
                                />
                            </label>
                        </div>
                        {formErrors.documenturl && <p className="text-red-500 text-xs mt-1">{formErrors.documenturl}</p>}
                    </div>

                    <div className="text-sm text-red-500">* indicates required field</div>
                </div>
            </GlassmorphicModal>

            {/* Delete Confirmation Modal using GlassmorphicModal */}
            <GlassmorphicModal
                isOpen={showDeleteConfirm}
                onClose={handleDeleteCancel}
                title="Confirm Delete"
                size="sm"
                footer={deleteModalFooter}
            >
                <p className="text-gray-700">
                    Are you sure you want to delete this Community Document? This action cannot be undone.
                </p>
            </GlassmorphicModal>
        </div >
    );
};

export default CommunityDocuments;